import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

/**
 * Networking pack — VPC/subnet/routing/connectivity fields. Applies to
 * resources where IP address layout, routing, and public exposure
 * matter: VPCs, subnets, gateways, load balancers, NAT, Route53.
 */
export const networkNetworkingFieldPack: FieldPack = {
  id: 'network-networking',
  name: 'Networking',
  description: 'CIDR, routing, gateways, flow logs, public exposure',
  version: '1.0.0',
  dependencies: ['network-base'],
  fields: [
    {
      id: 'cidr',
      label: 'CIDR Block',
      type: FieldType.TEXT,
      tags: ['networking'],
      priority: 95,
      placeholder: '10.0.0.0/16',
      sensitivity: 'internal',
    },
    {
      id: 'isPublic',
      label: 'Public Subnet',
      type: FieldType.BOOLEAN,
      tags: ['networking'],
      priority: 90,
      sensitivity: 'internal',
    },
    {
      id: 'routeTable',
      label: 'Route Table ID',
      type: FieldType.TEXT,
      tags: ['networking'],
      priority: 85,
      sensitivity: 'internal',
    },
    {
      id: 'internetGateway',
      label: 'Internet Gateway',
      type: FieldType.TEXT,
      tags: ['networking'],
      priority: 80,
      sensitivity: 'internal',
    },
    {
      id: 'natGateway',
      label: 'NAT Gateway',
      type: FieldType.TEXT,
      tags: ['networking'],
      priority: 75,
      sensitivity: 'internal',
    },
    {
      id: 'flowLogsEnabled',
      label: 'VPC Flow Logs',
      type: FieldType.BOOLEAN,
      tags: ['networking'],
      priority: 70,
      sensitivity: 'internal',
    },
    {
      id: 'dnsHostnames',
      label: 'DNS Hostnames',
      type: FieldType.BOOLEAN,
      tags: ['networking'],
      priority: 65,
      sensitivity: 'internal',
    },
    {
      id: 'peeringConnections',
      label: 'VPC Peering',
      type: FieldType.TEXT,
      tags: ['networking'],
      priority: 60,
      placeholder: 'pcx-abc123,pcx-def456',
      sensitivity: 'internal',
    },
  ],
};
